// ============================================
// WISHLISTCONTEXT.JS - Estado global wishlist
// ============================================

import React, { createContext, useContext, useState, useEffect } from 'react';

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const [wishlistItems, setWishlistItems] = useState(() => {
    try {
      const saved = localStorage.getItem('phys_wishlist');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      console.warn('WishlistContext: error reading localStorage', e);
      return [];
    }
  });

  // Persistir en localStorage cada vez que cambie
  useEffect(() => {
    localStorage.setItem('phys_wishlist', JSON.stringify(wishlistItems));
  }, [wishlistItems]);

  // Agregar producto
  const addToWishlist = (product) => {
    setWishlistItems(prev => {
      const exists = prev.find(item => item.id === product.id);
      if (exists) return prev;
      return [...prev, {
        id: product.id,
        name: product.title || product.name,
        image: product.thumbnail || product.image,
        price: product.price,
        handle: product.handle,
        addedAt: new Date().toISOString(),
      }];
    });
  };

  // Eliminar producto
  const removeFromWishlist = (productId) => {
    setWishlistItems(prev => prev.filter(item => item.id !== productId));
  };

  // Toggle — si está lo quita, si no está lo agrega
  const toggleWishlist = (product) => {
    const exists = wishlistItems.find(item => item.id === product.id);
    if (exists) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
  };

  // Verificar si un producto está en wishlist
  const isInWishlist = (productId) => {
    return wishlistItems.some(item => item.id === productId);
  };

  const wishlistCount = wishlistItems.length;

  return (
    <WishlistContext.Provider value={{
      wishlistItems,
      wishlistCount,
      addToWishlist,
      removeFromWishlist,
      toggleWishlist,
      isInWishlist,
    }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within a WishlistProvider');
  }
  return context;
}
